import { useCounterOfferStore } from '@/stores/counterOfferStore';
import { validateCounterOfferTerms } from '@/utils/formValidation/counterOfferForm';

/**
 * Hook for validating counter offer pool terms step
 */
export const useCounterOfferValidation = () => {
  const counterAmount = useCounterOfferStore((state) => state.counterAmount);
  const counterRate = useCounterOfferStore((state) => state.counterRate);
  const counterTermMonths = useCounterOfferStore((state) => state.counterTermMonths);
  const errors = useCounterOfferStore((state) => state.errors);
  const setErrors = useCounterOfferStore((state) => state.setErrors);

  const validate = () => {
    const validation = validateCounterOfferTerms({
      counterAmount,
      counterRate,
      counterTermMonths,
    });

    // Convert validation errors to store format
    const storeErrors: { amount?: string; rate?: string; term?: string } = {};
    if (validation.errors.counterAmount) {
      storeErrors.amount = validation.errors.counterAmount[0];
    }
    if (validation.errors.counterRate) {
      storeErrors.rate = validation.errors.counterRate[0];
    }
    if (validation.errors.counterTermMonths) {
      storeErrors.term = validation.errors.counterTermMonths[0];
    }

    setErrors(storeErrors);
    return validation.isValid;
  };

  return {
    validate,
    errors,
    getFieldError: (field: 'amount' | 'rate' | 'term') => errors[field],
  };
};
